module.exports = __webpack_public_path__ + "media/images/rank-2-37758c1c9034bc3bf1b3749dfea22819.svg";